/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { SandboxTenantRequest } from '../../models/sandbox-tenant-request';

export interface PostSandboxTenant$Params {
  action: 'create';
      body: SandboxTenantRequest
}

export function postSandboxTenant(http: HttpClient, rootUrl: string, params: PostSandboxTenant$Params, context?: HttpContext): Observable<StrictHttpResponse<HalJson>> {
  const rb = new RequestBuilder(rootUrl, postSandboxTenant.PATH, 'post');
  if (params) {
    rb.query('action', params.action, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<HalJson>;
    })
  );
}

postSandboxTenant.PATH = '/tenants/sandbox';
